<app-navigation></app-navigation>

<div class="top-navi-container">
  <button class="top-navi" (click)="onNavigateBack()" mat-button><mat-icon>arrow_back</mat-icon>Abbrechen</button>
</div>

<mat-card class="card">
  <mat-card-content>
    @if (assessmentData(); as assessmentData) {
      @if (assessmentData) {
        <div class="grid">
          <app-dynamic-table-input
            id="grasp"
            (inputData)="onGraspData($event)"
            [startTabIndex]="1"
            [note]="assessmentData.grasp.note"
            [title]="assessmentData.grasp.title"
            [manual]="assessmentData.grasp.manual"
            [data]="assessmentData.grasp.data"></app-dynamic-table-input>
          <app-dynamic-table-input
            id="grip"
            (inputData)="onGripData($event)"
            [startTabIndex]="20"
            [note]="assessmentData.grip.note"
            [title]="assessmentData.grip.title"
            [manual]="assessmentData.grip.manual"
            [data]="assessmentData.grip.data"></app-dynamic-table-input>
          <app-dynamic-table-input
            id="pinch"
            (inputData)="onPinchData($event)"
            [startTabIndex]="40"
            [note]="assessmentData.pinch.note"
            [title]="assessmentData.pinch.title"
            [manual]="assessmentData.pinch.manual"
            [data]="assessmentData.pinch.data"></app-dynamic-table-input>
          <app-dynamic-table-input
            id="gross"
            (inputData)="onGrossData($event)"
            [startTabIndex]="60"
            [note]="assessmentData.gross.note"
            [title]="assessmentData.gross.title"
            [manual]="assessmentData.gross.manual"
            [data]="assessmentData.gross.data"></app-dynamic-table-input>
        </div>
      }
    }
    <form class="input-form" [formGroup]="form">
      <mat-form-field class="input">
        <mat-label>💬 Öffentlicher Kommentar zum Testergebnis (optional)</mat-label>
        <textarea tabIndex="100" type="text" matInput formControlName="note" placeholder=""></textarea>
      </mat-form-field>
      <mat-form-field class="input" id="dateErhebung">
        <mat-label>Zeitpunkt der Testung</mat-label>
        <input type="datetime-local" matInput formControlName="assessmentTime" placeholder="" />
      </mat-form-field>
      @if (hasError().grasp || hasError().grip || hasError().gross || hasError().pinch) {
        <div class="error">
          <mat-error>Speichern nicht möglich, bitte zuerst die Eingabefehler korrigieren.</mat-error>
        </div>
      }
      @if (
        hasTriedToSave() &&
        (hasMissingInputs().grasp || hasMissingInputs().grip || hasMissingInputs().gross || hasMissingInputs().pinch)
      ) {
        <div class="error">
          <mat-error
            >Es fehlen Eingaben, bitte füllen Sie alle Eingabefelder aus. (Tipp: Sie können eine Seite komplett leer
            lassen.)</mat-error
          >
        </div>
      }
    </form>
    <div class="buttons">
      <button mat-flat-button color="secondary" (click)="location.back()">Abbrechen</button>
      @if (assessmentId) {
        <button mat-flat-button color="secondary" (click)="onDelete(assessmentId)">Testung löschen</button>
      }
      <button
        mat-flat-button
        color="primary"
        (click)="onSave()"
        [disabled]="hasError().grasp || hasError().grip || hasError().gross || hasError().pinch">
        Testung speichern
      </button>
    </div>
  </mat-card-content>
</mat-card>
